export const SIDEBAR = {
  IS_COLLAPSED: "SIDEBAR/IS_COLLAPSED",
};
